const welcomeStep = {
  target: `body`,
  placement: 'center',
  disableBeacon: true,
  title: 'Welcome',
  content:
    'Welcome to your Zippity Admin Portal! We want to show you around your Admin Portal to help you get started right away.',
};

const scheduleStep = {
  before: ({ redirect, setSelectedMenuItem }) => {
    redirect('/schedule');
    setSelectedMenuItem('Calendar');
  },
  target: `[data-tour-id='menu_schedule']`,
  disableBeacon: true,
  title: 'Calendar',
  content:
    'Configure the days you are available for service here. Click "Edit Availability" to set your recurring schedule.',
};

const serviceAreaTour = {
  before: ({ redirect, setSelectedMenuItem }) => {
    const managementSection = document.querySelector(
      '[data-tour-id="menu_shop_management"]',
    );
    if (managementSection?.className?.indexOf('MuiCollapse-entered') === -1) {
      managementSection.children[0].children[0].children[0].click();
    }
    redirect('/service-area');
    // Selecting menu item must be after the redirect so that the Dispatch menu item does not get reselected by default
    setSelectedMenuItem('service-area');
  },
  target: `[data-tour-id='menu_service-area']`,
  disableBeacon: true,
  title: 'Service Area',
  content:
    'Set your service area. Upload a list of zip codes or simply click on the map to select your preferred area.',
};

const quickApptStep = {
  target: `[data-tour-id='create-appointment']`,
  disableBeacon: true,
  title: 'Create Appointment',
  content:
    "You're ready to create your first appointment. Click the plus sign below to begin!",
};

const replayTourStep = {
  target: `[data-tour-id='profile-icon']`,
  disableBeacon: true,
  title: 'Replay Quick Start Guide',
  content:
    "That's all for now! If you want to come back and watch this Quick Start Guide again later, you can find it here.",
};

const zippityTour = {
  welcomeTourWithSchedule: {
    steps: [welcomeStep, scheduleStep, quickApptStep, replayTourStep],
  },
  welcomeTourWithServiceArea: {
    steps: [welcomeStep, serviceAreaTour, quickApptStep, replayTourStep],
  },
  welcomeTourWithScheduleAndServiceArea: {
    steps: [
      welcomeStep,
      serviceAreaTour,
      scheduleStep,
      quickApptStep,
      replayTourStep,
    ],
  },
};

export default zippityTour;
